import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { CriadorAgendamento } from "app/models/criador-agendamento.model";
import { Pageable } from "app/models/pageable-mode";
import { Observable } from "rxjs";

export abstract class AbAgendaAreaComum extends AppService {
  abstract getAllAreaComum(): Observable<any>;
  abstract createUpdateAgendaAreaComum(agenda);
  abstract mediar(agenda);
  abstract getAgendamentosByAreaEntreDatas(filter: AppFilter): Observable<any>;
  abstract getAgendamentosAbertosById(id): Observable<any>;
  abstract getAgendaAreaComumById(id: number): Observable<any>;
  abstract cancelamentoDoAgendamento(id: number);
  abstract existeAgendamentoParaAprovar(): Observable<any>;
  abstract getListarRelatorio(filter: string): Observable<any>;
  abstract getRelatorio(filter: string): Observable<any>;
  abstract getCriadoresAgendamento(filter: AppFilter): Observable<Pageable<CriadorAgendamento>>;
}
